module.exports = __webpack_public_path__ + "img/tooltipSOC.3f41732a.svg";